import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageHelmet from '@/components/feature/PageHelmet';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import ArticlesSection from './components/ArticlesSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '鬼父在线 - 官方入口 · 正版高清资源直达',
  description: '鬼父在线为您提供最全面的资源导航与观看指引，整合优质内容入口，帮助用户快速找到所需资源。',
  url: 'https://balnsj.cn/',
  isPartOf: {
    '@type': 'WebSite',
    name: '鬼父在线',
    url: 'https://balnsj.cn/',
  },
};

export default function Home() {
  return (
    <>
      <PageHelmet
        title="鬼父在线-官方入口·正版高清资源直达"
        description="鬼父在线为您提供最全面的资源导航与观看指引，围绕鬼父在线关键词整合优质内容入口，帮助用户快速找到所需资源，收藏本页获取最新更新动态与相关推荐。"
        keywords="鬼父在线,鬼父在线观看,鬼父在线入口,鬼父在线高清,鬼父在线资源,鬼父在线最新,鬼父在线导航"
        canonicalUrl="https://balnsj.cn/"
        jsonLd={homeJsonLd}
      />

      <Navbar />

      <main>
        <HeroSection />
        <StatsSection />
        <FeaturesSection />
        <CategoriesSection />
        <ArticlesSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}